// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"InformationUniversal_Wrapper___bfUi","Container":"InformationUniversal_Container__ZRXyw"};